import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { InputNumberModule } from 'primeng/inputnumber';

import { CommonBaseComponent } from '../common-base.component';

@Component({
  selector: 'app-inputnumber',
  templateUrl: './inputnumber.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    InputNumberModule,
  ],
})
export class InputNumberComponent extends CommonBaseComponent {
  @Input() maxLength: number = 250;
  maxFractionDigits: number = 2;
  minFractionDigits: number = 2;

  constructor() {
    super();
  }

  ngOnInit() {
    if (
      this.item?.config?.maxFractionDigits ||
      this.item?.config?.maxFractionDigits === 0
    )
      this.maxFractionDigits = this.item.config.maxFractionDigits;

    if (
      this.item?.config?.minFractionDigits ||
      this.item?.config?.maxFractionDigits == 0
    )
      this.minFractionDigits = this.item.config.minFractionDigits;
  }
}
